// src/components/IconSprite.tsx

export const IconSprite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
    {/* Cards Icon */}
    <symbol id="cards-icon" viewBox="0 0 24 24">
      <path d="M4 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4zm0 2h16v12H4V6zm2 2v8h12V8H6zm2 2h8v4H8v-4z" />
    </symbol>

    {/* Inventory Icon */}
    <symbol id="inventory-icon" viewBox="0 0 24 24">
      <path d="M20 2H4C3 2 2 3 2 4v16c0 1 1 2 2 2h16c1 0 2-1 2-2V4c0-1-1-2-2-2zm-9 14H7v-4h4v4zm0-6H7V6h4v4zm6 6h-4v-4h4v4zm0-6h-4V6h4v4z" />
    </symbol>

    {/* Explore Icon */}
    <symbol id="explore-icon" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z" />
    </symbol>

    {/* Store Icon */}
    <symbol id="store-icon" viewBox="0 0 24 24">
      <path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z" />
    </symbol>

    {/* Wallet Icon */}
    <symbol id="wallet-icon" viewBox="0 0 24 24">
      <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
    </symbol>
  </svg>
)
